import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { VoiceProvider } from './context/VoiceContext';

/*
 * Provider 顺序（不能随意调换）：
 *   AuthProvider     → 最外层，提供登录态
 *   SettingsProvider → 依赖登录态决定何时拉取用户设置
 *   VoiceProvider    → 依赖 settings 里的两个语音开关
 *
 * SettingsProvider 之所以必须在 AuthProvider 之内，是因为设置请求需要带 token；
 * 放在外层会导致「登录后设置不生效，必须刷新页面」。
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SettingsProvider>
        <VoiceProvider>
          <App />
        </VoiceProvider>
      </SettingsProvider>
    </AuthProvider>
  </React.StrictMode>
);
